module.exports = __webpack_public_path__ + "static/media/voice-disabled.38ae1f32.svg";